import React from 'react';
import PropTypes from 'prop-types';
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material';
import { withStyles } from '@mui/styles';
import { theme } from '../../../ThemeContext/ThemeObject';

const QontoConnector = withStyles(() => ({
  alternativeLabel: {
    top: 25,
    left: 'calc(-50% + 25px)',
    right: 'calc(50% + 25px)'
  },
  active: {
    '& $line': {
      borderColor: theme.palette.secondary.main
    }
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.secondary.main
    }
  },
  line: {
    borderColor: '#F3F3F3',
    borderTopWidth: 3,
    borderRadius: 1
  }
}))(StepConnector);

const StepperComponent = ({ activeStep, steps, classes }) => {
  StepperComponent.propTypes = {
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired
  };

  return (
    <div className={classes.stepSelect}>
      <Stepper
        classes={{ root: classes.stepperRoot }}
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
      >
        {steps.map((step, i) => (
          <Step key={i} classes={{ root: `${classes.stepItem}` }}>
            <StepLabel
              classes={{
                iconContainer: classes.stepLabelIconContainer,
                label: classes.stepLabelLabel,
                active: classes.stepLabelActive,
                completed: classes.stepLabelCompleted
              }}
              StepIconProps={{
                classes: {
                  root: classes.stepIconRoot,
                  active: classes.stepIconActive,
                  completed: classes.stepIconCompleted
                }
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default StepperComponent;
